import { SafetyStatus } from '../../../types';

// Extended SafetyStatus for the chart - 기존 SafetyStatus와 확장 타입
export interface SafetyStatusExtended extends SafetyStatus {
  lifeguard_count: number;
  emergency_equipment_count: number;
  crowd_level: number;
}

// 현재 시간 기준으로 임의 데이터 생성
const generateMockData = (count: number): SafetyStatusExtended[] => {
  const now = new Date();
  const data: SafetyStatusExtended[] = [];
  
  for (let i = 0; i < count; i++) {
    const timestamp = new Date(now.getTime() - (i * 60 * 60 * 1000)); // 매 시간 간격
    const lifeguardCount = Math.floor(Math.random() * 12) + 1; // 1-12명
    const emergencyCount = Math.floor(Math.random() * 15) + 1; // 1-15개
    const crowdLevel = Math.floor(Math.random() * 10) + 1; // 1-10 단계
    
    // 상태 계산
    let status: 'normal' | 'warning' | 'critical' = 'normal';
    if (lifeguardCount < 2 || emergencyCount < 3 || crowdLevel > 8) {
      status = 'critical';
    } else if (lifeguardCount < 4 || emergencyCount < 5 || crowdLevel > 6) {
      status = 'warning';
    }
    
    data.push({
      id: i + 1,
      pool_id: 1,
      status,
      timestamp: timestamp.toISOString(),
      lifeguards: lifeguardCount,
      emergencyEquipment: {
        aeds: Math.floor(emergencyCount / 3),
        firstAidKits: Math.floor(emergencyCount / 3),
        rescueTubes: Math.floor(emergencyCount / 3)
      },
      created_at: timestamp.toISOString(),
      updated_at: timestamp.toISOString(),
      lifeguard_count: lifeguardCount,
      emergency_equipment_count: emergencyCount,
      crowd_level: crowdLevel
    });
  }
  
  return data;
};

export const mockSafetyStatusData = generateMockData(24); // 24시간 데이터 